import React from "react";
import { useNavigate } from "react-router-dom";
import BasePage from "../components/layout/BasePage.tsx";
import { Button } from "@mui/material";
import Header from "../components/layout/Header.tsx";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <BasePage className="landing-box">
      <Header text={"Oops! That page doesn't exist."}>
        <div className={"header-form-box"}>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => navigate("/")}
          >
            Back To Home
          </Button>
        </div>
      </Header>
      <div className="body-box" />
    </BasePage>
  );
}
